var _path, _g, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDailyReward2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 177,
    viewBox: "0 0 183 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.9496 35.8789L98.7073 36.2991L105.358 37.5532L111.798 39.6212L117.925 42.4707L123.642 46.0566L128.859 50.3225L133.494 55.2011L137.474 60.6153L140.736 66.4799L143.229 72.7023L144.913 79.1845L145.761 85.8241V92.5164L144.913 99.1561L143.229 105.638L140.736 111.861L137.474 117.725L133.494 123.139L128.859 128.018L123.642 132.284L117.925 135.87L111.798 138.719L105.358 140.787L98.7073 142.041L91.9496 142.462L85.1918 142.041L78.5406 140.787L72.1009 138.719L65.9742 135.87L60.2572 132.284L55.0399 128.018L50.4048 123.139L46.4248 117.725L43.1628 111.861L40.6702 105.638L38.9863 99.1561L38.1376 92.5164V85.8241L38.9863 79.1845L40.6702 72.7023L43.1628 66.4799L46.4248 60.6153L50.4048 55.2011L55.0399 50.3225L60.2572 46.0566L65.9742 42.4707L72.1009 39.6212L78.5406 37.5532L85.1918 36.2991L91.9496 35.8789Z",
    fill: "url(#paint0_radial_7893_211892)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_7893_211892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.3228 5.78516L93.5617 52.8093C93.6948 55.6055 97.6149 56.1148 98.4581 53.4453L112.684 8.40486L102.824 54.4085C102.236 57.1492 105.904 58.6423 107.398 56.2706L132.702 16.0994L111.419 58.1755C110.151 60.6823 113.333 63.0592 115.377 61.1324L150.121 28.3852L118.803 63.9154C116.941 66.0281 119.439 69.133 121.901 67.7665L163.845 44.4904L124.481 71.2949C122.147 72.8835 123.811 76.518 126.538 75.791L173.012 63.403L128.053 79.8491C125.398 80.8201 126.128 84.7574 128.955 84.7117L177.046 83.9346L129.265 89.0118C126.453 89.3106 126.209 93.3092 128.963 93.9485L175.695 104.795L128.039 98.1668C125.241 97.7776 124.036 101.593 126.549 102.882L169.041 124.674L124.479 106.707C121.864 105.653 119.768 109.05 121.883 110.914L157.505 142.322L118.85 114.092C116.578 112.433 113.717 115.196 115.295 117.524L141.81 156.631L111.539 119.88C109.756 117.714 106.304 119.666 107.239 122.311L122.942 166.7L103.016 123.75C101.837 121.209 98.0124 122.219 98.2414 125.01L102.088 171.898L93.7915 125.493C93.2989 122.737 89.3467 122.737 88.8541 125.493L80.5575 171.898L84.4042 125.01C84.6332 122.219 80.8085 121.209 79.6298 123.75L59.7034 166.7L75.4062 122.311C76.3419 119.666 72.89 117.714 71.1062 119.88L40.8361 156.631L67.3505 117.524C68.929 115.196 66.0672 112.433 63.7958 114.092L25.141 142.322L60.7627 110.914C62.8776 109.05 60.7814 105.653 58.1664 106.707L13.6044 124.674L56.0961 102.882C58.6097 101.593 57.4042 97.7776 54.6062 98.1668L6.95109 104.795L53.6826 93.9485C56.4368 93.3092 56.1921 89.3106 53.3806 89.0118L5.59917 83.9346L53.691 84.7118C56.5171 84.7574 57.2475 80.8201 54.593 79.849L9.6336 63.403L56.1077 75.791C58.835 76.518 60.4981 72.8835 58.1651 71.2949L18.8008 44.4904L60.7443 67.7665C63.2068 69.133 65.7047 66.0281 63.8425 63.9154L32.5249 28.3852L67.2687 61.1324C69.3129 63.0592 72.4946 60.6823 71.2266 58.1755L49.9435 16.0994L75.2476 56.2706C76.7416 58.6423 80.4091 57.1492 79.8217 54.4085L69.9621 8.40486L84.1875 53.4453C85.0307 56.1148 88.9508 55.6056 89.0839 52.8093L91.3228 5.78516Z",
    fill: "url(#paint1_radial_7893_211892)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_7893_211892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.687 83.6388C124.056 101.757 109.41 115.245 92.973 113.766C76.5361 112.287 69.5347 110.28 72.3636 78.8408C75.1309 48.0855 82.4398 46.6762 98.8767 48.1552C115.314 49.6342 127.317 65.5207 125.687 83.6388Z",
    fill: "#F19018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6169 113.281C71.18 111.802 59.1768 95.9154 60.8071 77.7974C62.4373 59.6793 77.0837 46.1907 93.5206 47.6697C109.957 49.1487 121.961 65.0352 120.33 83.1533C118.7 101.271 104.054 114.76 87.6169 113.281Z",
    fill: "url(#paint2_linear_7893_211892)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.261 73.6039C113.481 85.7622 107.089 98.6634 95.9834 102.42C84.8781 106.176 73.265 99.3644 70.0449 87.206C66.8248 75.0477 73.217 62.1465 84.3223 58.3903C95.4276 54.6342 107.041 61.4456 110.261 73.6039Z",
    fill: "#F39E09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1362 60.1455C97.2415 56.3893 103.383 61.6973 106.083 65.1319C99.4331 68.4343 82.6016 83.7341 78.0111 98.4224C64.6522 83.3904 75.0309 63.9016 86.1362 60.1455Z",
    fill: "#FFAA16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4487 101.528C77.3895 98.6973 74.2298 94.2995 72.7753 88.8074C69.5562 76.6531 75.9509 63.7467 87.0526 59.9918C92.069 58.2951 97.1824 58.7496 101.587 60.883C96.654 57.4513 90.4181 56.3285 84.3223 58.3903C73.2206 62.1452 66.8258 75.0516 70.0449 87.206C71.8094 93.8683 76.1022 98.9307 81.4487 101.528Z",
    fill: "#E88102",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.617 78.0627C107.338 77.2988 106.896 76.0026 105.884 75.9115L93.9975 74.8419C93.145 74.7652 92.6493 73.7971 93.052 72.9954L98.3901 62.37C99.0378 61.0807 94.701 59.6128 93.7243 60.6475L76.4122 82.1595C75.6911 82.9234 76.1324 84.2196 77.1447 84.3107L89.0313 85.3803C89.8838 85.457 90.3795 86.4251 89.9768 87.2267L81.8123 98.3328C81.1646 99.6221 85.567 100.361 86.5438 99.3262L106.617 78.0627Z",
    fill: "#E88711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.63 77.7931C104.351 77.0293 103.91 75.733 102.897 75.6419L91.0107 74.5724C90.1582 74.4957 89.6625 73.5276 90.0652 72.7259L95.4033 62.1004C96.051 60.8112 94.475 59.5917 93.4982 60.6264L73.4254 81.89C72.7043 82.6539 73.1456 83.9501 74.1579 84.0412L86.0445 85.1107C86.897 85.1874 87.3927 86.1555 86.99 86.9572L81.6519 97.5827C81.0042 98.872 82.5802 100.091 83.557 99.0567L103.63 77.7931Z",
    fill: "#FFD83B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2594 52.6815C99.4232 52.1128 99.1227 51.5139 98.5821 51.367C95.3631 50.492 92.0137 50.234 88.6917 50.6083C85.0332 51.0205 81.4796 52.1915 78.2337 54.0542C74.9879 55.917 72.1134 58.4351 69.7744 61.4648C67.6504 64.2159 66.0058 67.3399 64.9155 70.6879C64.7324 71.2502 65.0351 71.8478 65.5701 72.0155V72.0155C66.1051 72.1831 66.6698 71.8572 66.8544 71.2954C67.8657 68.2176 69.3827 65.3455 71.3373 62.8138C73.507 60.0034 76.1734 57.6676 79.1842 55.9397C82.195 54.2118 85.4913 53.1257 88.885 52.7433C91.9421 52.3989 95.0242 52.6317 97.9884 53.4279C98.5294 53.5732 99.0955 53.2502 99.2594 52.6815V52.6815Z",
    fill: "#FFE77E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2506 109.321C90.2426 109.914 90.69 110.399 91.2494 110.379C97.434 110.167 103.401 107.789 108.214 103.618C108.649 103.241 108.693 102.561 108.326 102.117V102.117C107.959 101.674 107.321 101.635 106.884 102.011C102.448 105.833 96.9644 108.018 91.2782 108.231C90.7188 108.252 90.2585 108.728 90.2506 109.321V109.321Z",
    fill: "#FFE77E"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.379 45.9102L70.3365 57.7149L80.1628 51.1034L71.5306 59.2121L82.8262 62.7725L71.1044 61.0792L75.3636 72.1303L69.379 61.9101L63.3944 72.1303L67.6536 61.0792L55.9318 62.7725L67.2274 59.2121L58.5951 51.1034L68.4215 57.7149L69.379 45.9102Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.147 96.0664L115.8 104.115L122.5 99.6072L116.614 105.136L124.316 107.563L116.323 106.409L119.227 113.944L115.147 106.975L111.067 113.944L113.971 106.409L105.978 107.563L113.68 105.136L107.794 99.6072L114.494 104.115L115.147 96.0664Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_7893_211892)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M122.83 140.749L128.345 129.479C128.449 129.266 128.496 129.031 128.481 128.797C128.465 128.562 128.388 128.335 128.257 128.136C128.126 127.938 127.945 127.774 127.731 127.661C127.517 127.548 127.276 127.488 127.032 127.488H115.421C115.116 127.488 114.819 127.58 114.572 127.752C114.325 127.923 114.14 128.165 114.043 128.443L108.238 145.193C108.189 145.335 108.164 145.484 108.164 145.634V152.613C108.164 152.983 108.317 153.338 108.589 153.6C108.861 153.862 109.23 154.009 109.615 154.009H127.032C127.276 154.009 127.517 153.95 127.731 153.836C127.945 153.723 128.126 153.559 128.257 153.361C128.388 153.162 128.465 152.935 128.481 152.7C128.496 152.466 128.449 152.231 128.345 152.018L122.83 140.749Z",
    fill: "#3703A4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0205 128.443C69.9242 128.165 69.7394 127.923 69.4922 127.752C69.2449 127.58 68.9479 127.488 68.6432 127.488H57.0324C56.7887 127.489 56.5492 127.55 56.3361 127.663C56.1229 127.777 55.943 127.941 55.8128 128.139C55.6827 128.337 55.6065 128.563 55.5914 128.797C55.5762 129.031 55.6226 129.265 55.7262 129.477L61.2413 140.747L55.7262 152.018C55.6223 152.231 55.5756 152.465 55.5906 152.699C55.6056 152.933 55.6817 153.16 55.8119 153.358C55.9421 153.556 56.1221 153.72 56.3355 153.834C56.5488 153.948 56.7885 154.008 57.0324 154.009H74.4486C74.8335 154.009 75.2027 153.862 75.4748 153.6C75.747 153.338 75.8999 152.983 75.8999 152.613V145.634C75.9 145.484 75.8751 145.335 75.8259 145.193L70.0205 128.443Z",
    fill: "#3703A4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M115.348 123.445H68.5528C67.6348 123.445 66.8906 124.163 66.8906 125.049V149.898C66.8906 150.784 67.6348 151.502 68.5528 151.502H115.348C116.266 151.502 117.011 150.784 117.011 149.898V125.049C117.011 124.163 116.266 123.445 115.348 123.445Z",
    fill: "#5A34E1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7893_211892",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 123,
    width: 52,
    height: 29
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M115.348 123.445H68.5528C67.6348 123.445 66.8906 124.163 66.8906 125.049V149.898C66.8906 150.784 67.6348 151.502 68.5528 151.502H115.348C116.266 151.502 117.011 150.784 117.011 149.898V125.049C117.011 124.163 116.266 123.445 115.348 123.445Z",
    fill: "#FF463A"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7893_211892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.736 137.769C102.736 145.022 97.9486 150.902 92.0429 150.902C86.1372 150.902 81.3496 145.022 81.3496 137.769C81.3496 130.516 86.1372 124.637 92.0429 124.637C97.9486 124.637 102.736 130.516 102.736 137.769ZM83.2854 137.769C83.2854 143.709 87.2063 148.525 92.0429 148.525C96.8795 148.525 100.8 143.709 100.8 137.769C100.8 131.829 96.8795 127.014 92.0429 127.014C87.2063 127.014 83.2854 131.829 83.2854 137.769Z",
    fill: "#8133CF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.944 137.77C112.944 151.946 103.586 163.439 92.0431 163.439C80.5001 163.439 71.1426 151.946 71.1426 137.77C71.1426 123.594 80.5001 112.102 92.0431 112.102C103.586 112.102 112.944 123.594 112.944 137.77ZM74.9262 137.77C74.9262 149.38 82.5897 158.792 92.0431 158.792C101.496 158.792 109.16 149.38 109.16 137.77C109.16 126.16 101.496 116.748 92.0431 116.748C82.5897 116.748 74.9262 126.16 74.9262 137.77Z",
    fill: "#8133CF",
    fillOpacity: 0.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_7893_211892",
    x: 0.583465,
    y: 0.7695,
    width: 181.479,
    height: 176.145,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.50783,
    result: "effect1_foregroundBlur_7893_211892"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_7893_211892",
    x: 40.5961,
    y: 41.289,
    width: 105.301,
    height: 106.446,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.7931
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.0313
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7893_211892"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7893_211892",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_7893_211892",
    x: 55.5879,
    y: 123.445,
    width: 72.8955,
    height: 32.9955,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.43299
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7893_211892"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7893_211892",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_7893_211892",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(91.9495 89.1703) rotate(90.533) scale(49.808 51.1567)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD480",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#FFC85C",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552083,
    stopColor: "#FFC75B",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC759",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_7893_211892",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(91.3227 89.1704) rotate(90) scale(61.6467 95.1078)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC85C",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC759",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7893_211892",
    x1: 93.5206,
    y1: 47.6697,
    x2: 87.6169,
    y2: 113.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541667,
    stopColor: "#FFBF1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC536"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyReward2);
export default __webpack_public_path__ + "static/media/daily-reward2.ded0a2417d5b85185653a89eec57dd59.svg";
export { ForwardRef as ReactComponent };